import {
  Box,
  Button,
  Stack,
  Tab,
  Tabs,
  TextField,
  Typography,
  Link,
  FormHelperText,
  CircularProgress,
  IconButton,
} from "@mui/material";

import {
  CustomTabPanel,
  CustomeDialog,
  DeleteModal,
  InputControl,
  Loader,
  LoadingButton,
  PageListLayout,
} from "../../../shared";
import DeleteIcon from "../../../assets/images/Icons/Vector (11).svg";
import { CommonBatchTabs } from "./CommonBatchTabs";
import editIcon from "../../../assets/images/Icons/ic_edit.svg";
import {
  DeleteAlertDialog,
  RegenerateDialog,
  SettingsView,
  TemplateStoreList,
} from "../components";
import { useLocation, useParams } from "react-router-dom";
import { useStoreDetailsTemplates, useTemplates } from "../hooks";
import { CustomDialogTemplate } from "../../../shared/components/CustomDialogTemplate";
import { NameDialog } from "../components/NameDialog";
import { useNavigate } from "react-router-dom";
import { CommonTab } from "./CommonTab";
import { GenerateTemplates } from "./GenerateTemplates";
import copyIcon from "../../../assets/images/Icons/copyImage.svg";
import { navigateBasedOnUserType } from "../../../utils";
import TemplateStatusChangeDialog from "../components/TemplateStatusChangeDialog";
import { BatchSplitDialog } from "./BatchSplitDialog";
import React from "react";
import SimpleReactValidator from "simple-react-validator";
import moment from "moment";
import { CreateDateAssignTab } from "./CreateDateAssignTab";
import { CreateStoreAssignTab } from "./CreateStoreAssignTab";
import { useStores } from "../../Store/hooks";
import { TemplateDialogContent } from "../components/TemplateDialogContent";

const statusList = [
  {
    id: 1,
    label: "Active",
  },
  {
    id: 0,
    label: "Inactive",
  },
];

export const TemplatesDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { search, pathname } = useLocation();
  const { listQuery: storeListData } = useStores({ isList: true });
  const isStoreAdmin = pathname.includes("store-admin");

  const handleChange = (event, newValue) => {
    if (isStoreAdmin) {
      navigate(`/store-admin/templates/details/${id}${newValue}`);
    } else {
      navigate(`/templates/details/${id}${newValue}`);
    }
  };

  const {
    state: states,
    templateDetails,
    createScedule,
    templates,
    onDeleteTagSelect,
    onChangeDate,
    RadioButtonChange,
    onChangeSceduler,
    templateProductionDaysDetails,
    dropdownListQuery,
    handleRepeatOptionChange,
    weekOfMonthOptionChange,
    monthOptionChange,
    weekDaysOptionChange,
    onChangeYear,
    onChangeHandler,
    DaysOfWeekOptionChange,
    WeekDaysOptionChange,
    OptionChange,
    handleClickOpen,
    handleDayClick,
    handleDeleteScheduledDatesDialog,
    handleAlertClickOpen,
    onChangeMultipleDate,
    handleClickSaveOpen,
    handleClickUpdateOpen,
    setTemplates,
    RemoveButtonHandeler,
    handleScheduleOpen,
    handleClickUpdateClose,
    categorylistQuery,
    handleOpenClick,
    handleOpenClickDetailCopy,
    updateTableData,
    onChangeFilter,
    handleRecipes,
    onUpdate,
    onChangeEffectiveDate,
    handleNameOpen,
    onChange,
    onNameSubmit,
    validator,
    forceUpdate,
    handleRegenerateOpenClick,
    onSearchChange,
    deleteInfo,
    resetDeleteInfo,
    onDeleteDetails,
    confirmDelete,
    filterRecipeList,
    handleCustomTableChange,
    reGenerateBatch,
    searchHandler,
    updateTemplateName,
    handleBack,
    createTemplateName,
    copyBatch,
    generateBatch,
    batchFilter1,
    handleOptionChangeRecipe,
    handleOptionChangeRecipeBatch,
    onSave,
    onNameCreateSubmit,
    onSubmits,
    onSaveCustomDays,
    handleAddCustomDays,
    isDeletable,
    isStatusChange,
    isEditable,
    globalData,
    isCopyTemplate,
    isStoreAssign,
    handleCustomFieldChange,
    recipelistQuery,
    handleClose,
    handleRemoveRecurringDate,
    confirmDeleteRecurringDates,
    handleBatchClick,
    handleRecipeClick,
    value,
    setValue,
    handleNextButton,
    handleStoreAssignDialog,
    handleCreateDateAssign,
    onSubmitStatus,
    selectedDates,
    setSelectedDates,
    allDates,
    allProductionDates,
    selectedProductionDates,
    setSelectedProductionDates,
    unselectedProductionDates,
    setUnselectedProductionDates,
    templateProductionDaysList,
    handleBatchSplitUpdate,
    selectedIndex,
    setSelectedIndex,
    setEditedMap,
    setFocusedField,
    editedMap,
    focusedField,
    updateBatchSplit,
    handleAddBatch,
    handleDeleteBatch,
    handleDeleteBatchDialog,
    hasAnyBatchError,
    hasLastBatchWeightZero,
  } = useTemplates({
    details_id: id,
    dropdownlist: true,
    list: true,
    updateId: id,
    isList: false,
  });

  const {
    state,
    assignedStoreState,
    handleModal,
    handleStoreDialogSelect,
    handleStoreToRecipe,
    onSearchHandler,
    pagination,
    setPagination,
    assingedStoreListQueryTemplate,
    confirmDeleteStrores,
    storesDeleteInfo,
    handleDeleteStores,
    clearStoresDeleteInfo,
    sorting,
    setSorting,
    isLoading,
    setState,
    onChangeStoreEffectiveDate,
    handleStoreDeleteDialog,
    onChangeEffectiveDates,
  } = useStoreDetailsTemplates({
    templateId: id,
    isAssignedstoreList: true,
    templates,
  });
  const dateValidator = React.useRef(
    new SimpleReactValidator({
      autoForceUpdate: { forceUpdate: forceUpdate },
      validators: {
        Item: {
          message: "Each date must be today or in the future.",
          required: true,
          rule: (values) => {
            return (
              values &&
              values?.every(
                (value) =>
                  value && moment(value)?.isSameOrAfter(moment(), "day")
              )
            );
          },
        },
      },
    })
  );

  const ListofDropdown = dropdownListQuery?.data?.drop_down_list; //day week month

  const WeekOfMonth = dropdownListQuery?.data?.Week_Number_List; //first second...

  const MonthDropdown = dropdownListQuery?.data?.Month_List; //jan feb mar

  const WeekDays = dropdownListQuery?.data?.week_values; // sun mon tue

  const onCreateSubmit = (type) => {
    if (validator.current.allValid()) {
      onSave(type);
    } else {
      validator.current.showMessages();
      forceUpdate(1);
    }
  };

  const breadcrumbs = [
    <Link
      underline="none"
      key="1"
      color="#1760D2"
      onClick={(e) =>
        navigateBasedOnUserType(`/templates`, isStoreAdmin, navigate)
      }
      sx={{ fontSize: "14px", fontWeight: 400 }}
    >
      Templates
    </Link>,
    <Typography
      key="2"
      color="inherit"
      sx={{ fontSize: "14px", fontWeight: 400 }}
    >
      {templateDetails?.data?.template_name}
    </Typography>,
  ];

  const handleSubmit = (type, id) => {
    if (dateValidator.current.allValid()) {
      if (id) {
        handleClickUpdateOpen(type, id);
      } else {
        onSubmit();
      }
    } else {
      dateValidator.current.showMessages();
      forceUpdate(1);
    }
  };
  const onSubmit = () => {
    if (validator.current.allValid()) {
      onNameCreateSubmit();
    } else {
      validator.current.showMessages();
      forceUpdate(1);
    }
  };
  const handleOnClose = () => {
    const templateId = states?.templateDetails?.data?.template_id
      ? states?.templateDetails?.data?.template_id
      : id;
    isStoreAdmin
      ? navigate(`/store-admin/templates/details/${templateId}`)
      : navigate(`/templates/details/${templateId}`);
    handleOpenClickDetailCopy(false, templateId);
  };

  const renderTableFooter = () => {
    if (
      !states.isCreate &&
      !templates.isCreateDateAssign &&
      !templates.isCreateStoreAssign
    ) {
      return (
        <Stack
          direction="row"
          justifyContent="flex-end"
          spacing={2}
          padding="10px"
          marginTop="auto"
        >
          {/*
          Rules can't find in validator, so it's not working 
          <Box sx={{ alignContent: "center" }}>
            <FormHelperText sx={{ color: "#C60808" }}>
              {validator?.current?.message(
                "Recipe field",
                batchFilter1,
                "Item"
              )}
            </FormHelperText>
          </Box> */}
          <Button
            variant="outlined"
            onClick={() => handleOpenClickDetailCopy(false)}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            disabled={generateBatch?.isPending || copyBatch?.isPending}
            onClick={() => onCreateSubmit("initial")}
          >
            Generate Batches
          </Button>
        </Stack>
      );
    } else if (templates.isCreateStoreAssign) {
      return (
        <Stack
          direction="row"
          justifyContent="space-between"
          padding="10px"
          alignItems="center"
        >
          <Stack direction="row" spacing={1} alignItems="center">
            <Typography>Set Template Name:</Typography>
            <TextField
              variant="outlined"
              name="template_name"
              required
              disabled={
                state.isDuplicate ||
                templates.isCreateStoreAssign ||
                templates.isCreateDateAssign
              }
              value={templates.data.template_name}
              onChange={onChange}
              sx={{
                borderRadius: "10px",
                height: "36px",
                width: "405px",
                "& .MuiOutlinedInput-root": {
                  minHeight: "32px",
                  width: "405px",
                  borderRadius: "10px",
                },
              }}
              error={
                validator.current.message(
                  "Template Name",
                  templates.data.template_name,
                  "required"
                )
                  ? true
                  : false
              }
              helperText={validator.current.message(
                "Template Name",
                templates.data.template_name,
                "required"
              )}
            />
          </Stack>
          <Stack sx={{ gap: "8px" }} direction="row">
            <Button
              key="cancel"
              variant="outlined"
              onClick={() => handleOpenClickDetailCopy(false)}
              sx={{
                height: "36px",
                border: "1px solid #BCC7DB",
                borderRadius: "10px",
                color: "#000000",
                bgcolor: "#F5F8FC",
              }}
            >
              Cancel
            </Button>
            <Button
              key="generate"
              variant="contained"
              sx={{
                height: "36px",
                border: "1px solid #BCC7DB",
                borderRadius: "10px",
              }}
              onClick={() => {
                templates.selectedStores.length > 0
                  ? handleAlertClickOpen(
                      true,
                      state?.templateDetails?.data?.template_id
                    )
                  : handleOnClose();
              }}
            >
              Save
            </Button>
          </Stack>
        </Stack>
      );
    } else if (templates.isCreateDateAssign) {
      return (
        <Stack
          direction="row"
          justifyContent="space-between"
          padding="12px"
          alignItems="center"
        >
          <Stack direction="row" spacing={1} alignItems="center">
            <Typography>Set Template Name:</Typography>
            <TextField
              variant="outlined"
              name="template_name"
              required
              disabled={
                state.isDuplicate ||
                templates.isCreateDateAssign ||
                templates.isCreateStoreAssign
              }
              value={templates.data.template_name}
              onChange={onChange}
              sx={{
                borderRadius: "10px",
                height: "36px",
                width: "405px",
                "& .MuiOutlinedInput-root": {
                  minHeight: "28px",
                  width: "405px",
                  borderRadius: "10px",
                },
              }}
              error={
                validator.current.message(
                  "Template Name",
                  templates.data.template_name,
                  "required"
                )
                  ? true
                  : false
              }
              helperText={validator.current.message(
                "Template Name",
                templates.data.template_name,
                "required"
              )}
            />
          </Stack>
          <Stack sx={{ gap: "8px" }} direction="row">
            <Button
              key="cancel"
              variant="outlined"
              onClick={() => handleOpenClickDetailCopy(false)}
              sx={{
                height: "36px",
                border: "1px solid #BCC7DB",
                borderRadius: "10px",
                color: "#000000",
                bgcolor: "#F5F8FC",
              }}
            >
              Cancel
            </Button>
            <Button
              key="generate"
              variant="contained"
              sx={{
                height: "36px",
                border: "1px solid #BCC7DB",
                borderRadius: "10px",
              }}
              disabled={createTemplateName?.isPending}
              onClick={() => {
                !isStoreAdmin
                  ? templates.is_create_date_assign === 1
                    ? handleSubmit(true, id)
                    : handleNextButton()
                  : templates.is_create_date_assign === 1
                    ? handleSubmit(true, id)
                    : handleOpenClickDetailCopy(
                        false,
                        state?.templateDetails?.data?.template_id
                          ? states?.templateDetails?.data?.template_id
                        : id
                      );
              }}
              startIcon={
                createTemplateName?.isPending ? (
                  <CircularProgress size={20} color="inherit" />
                ) : null
              }
            >
              {templates.is_create_date_assign === 1 ? "Next" : "Skip & Next"}
            </Button>
          </Stack>
        </Stack>
      );
    } else {
      return (
        <Stack
          direction="row"
          justifyContent="space-between"
          padding="12px"
          alignItems="center"
        >
          <Stack direction="row" spacing={1} alignItems="center">
            <Typography>Set Template Name:</Typography>
            <TextField
              variant="outlined"
              name="template_name"
              required
              disabled={
                state.isDuplicate ||
                templates.isCreateDateAssign ||
                templates.isCreateStoreAssign
              }
              value={templates.data.template_name}
              onChange={onChange}
              sx={{
                borderRadius: "10px",
                height: "36px",
                width: "405px",
                "& .MuiOutlinedInput-root": {
                  minHeight: "28px",
                  width: "405px",
                  borderRadius: "10px",
                },
              }}
              error={
                validator.current.message(
                  "Template Name",
                  templates.data.template_name,
                  "required"
                )
                  ? true
                  : false
              }
              helperText={validator.current.message(
                "Template Name",
                templates.data.template_name,
                "required"
              )}
            />
          </Stack>
          <Stack sx={{ gap: "8px" }} direction="row">
            <Button
              key="cancel"
              variant="outlined"
              onClick={() => handleOpenClickDetailCopy(false)}
              sx={{
                height: "36px",
                border: "1px solid #BCC7DB",
                borderRadius: "10px",
                color: "#000000",
                bgcolor: "#F5F8FC",
              }}
            >
              Cancel
            </Button>
            <Button
              key="generate"
              variant="contained"
              sx={{
                height: "36px",
                border: "1px solid #BCC7DB",
                borderRadius: "10px",
              }}
              disabled={createTemplateName?.isPending}
              onClick={() => {
                onSubmit();
              }}
              startIcon={
                createTemplateName?.isPending ? (
                  <CircularProgress size={20} color="inherit" />
                ) : null
              }
            >
              Generate
            </Button>
          </Stack>
        </Stack>
      );
    }
  };

  const renderContent = (globalData) => {
    if (
      templates.isShowErrorMessage &&
      !state.isCreate &&
      !templates.isCreateDateAssign &&
      !templates.isCreateStoreAssign
    ) {
      return (
        <BatchSplitDialog
          templates={templates}
          setTemplates={setTemplates}
          handleBatchSplitUpdate={handleBatchSplitUpdate}
          selectedIndex={selectedIndex}
          setSelectedIndex={setSelectedIndex}
          setEditedMap={setEditedMap}
          setFocusedField={setFocusedField}
          editedMap={editedMap}
          focusedField={focusedField}
          updateBatchSplit={updateBatchSplit}
          handleAddBatch={handleAddBatch}
          handleDeleteBatch={handleDeleteBatch}
          handleDeleteBatchDialog={handleDeleteBatchDialog}
          globalData={globalData}
        />
      );
    } else {
      if (
        !states.isCreate &&
        !templates.isCreateDateAssign &&
        !templates.isCreateStoreAssign
      ) {
        return (
          <GenerateTemplates
            templates={templates}
            categorylistQuery={categorylistQuery}
            handleRecipes={handleRecipes}
            onChangeFilter={onChangeFilter}
            updateTableData={updateTableData}
            onSearchChange={onSearchChange}
            handleCustomTableChange={handleCustomTableChange}
            searchHandler={searchHandler}
            handleCustomFieldChange={handleCustomFieldChange}
            recipelistQuery={recipelistQuery}
            validator={validator}
            templateDetails={templateDetails}
          />
        );
      } else if (
        states.isCreate &&
        !templates.isCreateDateAssign &&
        !templates.isCreateStoreAssign
      ) {
        return (
          <CommonTab
            state={states?.templateDetails}
            templates={templates}
            handleOptionChangeRecipeBatch={handleOptionChangeRecipeBatch}
            handleOptionChangeRecipe={handleOptionChangeRecipe}
            globalData={globalData}
            setTemplates={setTemplates}
          />
        );
      } else if (
        templates.isCreateDateAssign &&
        !templates.isCreateStoreAssign &&
        states.isCreate
      ) {
        return (
          <CreateDateAssignTab
            templates={templates}
            onChangeMultipleDate={onChangeMultipleDate}
            onSaveCustomDays={onSaveCustomDays}
            onDeleteTagSelect={onDeleteTagSelect}
            WeekDays={WeekDays}
            handleRepeatOptionChange={handleRepeatOptionChange}
            ListofDropdown={ListofDropdown}
            onChangeHandler={onChangeHandler}
            RadioButtonChange={RadioButtonChange}
            handleDayClick={handleDayClick}
            MonthDropdown={MonthDropdown}
            monthOptionChange={monthOptionChange}
            WeekOfMonth={WeekOfMonth}
            weekOfMonthOptionChange={weekOfMonthOptionChange}
            weekDaysOptionChange={weekDaysOptionChange}
            onChangeYear={onChangeYear}
            onChangeSceduler={onChangeSceduler}
            onChangeDate={onChangeDate}
            DaysOfWeekOptionChange={DaysOfWeekOptionChange}
            OptionChange={OptionChange}
            WeekDaysOptionChange={WeekDaysOptionChange}
            handleCreateDateAssign={handleCreateDateAssign}
            validator={dateValidator}
          />
        );
      } else if (
        templates.isCreateStoreAssign &&
        states.isCreate &&
        !templates.isCreateDateAssign
      ) {
        return (
          <CreateStoreAssignTab
            storeListData={storeListData}
            templates={templates}
            state={state}
            handleStoreAssignDialog={handleStoreAssignDialog}
            handleAlertClickOpen={handleAlertClickOpen}
            setTemplates={setTemplates}
            id={id}
            onClose={handleOnClose}
          />
        );
      }
    }
  };

  return (
    <PageListLayout
      breadcrumbs={breadcrumbs}
      headerText={
        <Box sx={{ display: "flex", gap: "12px", alignItems: "center" }}>
          <Typography
            sx={{
              fontWeight: 600,
              fontSize: "24px",
            }}
          >
            {templateDetails.isLoading
              ? "Loading..."
              : templateDetails?.data?.template_name}
          </Typography>
          {isEditable && (
            <IconButton
              sx={{
                background: "#E6EEF7",
                ":hover": {
                  background: "#E6EEF7",
                  opacity: "0.8",
                },
              }}
              onClick={() => handleNameOpen(true)}
            >
              <img alt="edit" src={editIcon} width={20} height={20} />
            </IconButton>
          )}
        </Box>
      }
      rightContent={
        <React.Fragment>
          <Stack flexDirection="row" gap="12px" flexWrap="wrap">
            {isStatusChange && (
              <InputControl
                type="dropdown"
                options={statusList}
                getOptionLabel={(option) => option?.label || ""}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                disableClearable={true}
                style={{
                  width: "160px",
                }}
                value={
                  statusList.find(
                    (option) => option.id === templateDetails?.data?.status
                  ) || null
                }
                renderInput={(params) => (
                  <TextField {...params} size="small" placeholder="Status" />
                )}
                onChange={(event, option) => {
                  handleDeleteScheduledDatesDialog(
                    true,
                    templateDetails?.data,
                    event,
                    option
                  );
                }}
              />
            )}

            {isEditable && (
              <Button
                type="button"
                color="gray2"
                size="small"
                variant="outlined"
                onClick={() => handleOpenClick(true, id)}
                disabled={templateDetails?.data?.status === 0}
              >
                Regenerate Batch
              </Button>
            )}

            <Stack gap="8px" flexDirection="row">
              {isCopyTemplate && (
                <IconButton onClick={() => handleOpenClickDetailCopy(true, id)}>
                  <Box component="img" src={copyIcon} height={20} width={20} />
                </IconButton>
              )}

              {isDeletable && (
                <IconButton
                  onClick={() =>
                    onDeleteDetails(
                      id,
                      assignedStoreState,
                      templateProductionDaysDetails,
                      templateDetails?.data,
                      allProductionDates
                    )
                  }
                >
                  <Box
                    component="img"
                    alt="delete"
                    src={DeleteIcon}
                    height={20}
                    width={20}
                  />
                </IconButton>
              )}
            </Stack>
          </Stack>

          {templates?.isStatusOpen && (
            <CustomeDialog
              PaperProps={{
                sx: {
                  minWidth: "570px",
                  minHeight: "280px",
                  borderRadius: "10px",
                },
              }}
              open={templates?.isStatusOpen}
              title={
                <Typography
                  sx={{
                    padding: "20px 20px 8px 20px",
                    fontWeight: "500",
                    fontSize: "20px",
                    lineHeight: "24.2px",
                    width: "590px",
                  }}
                >
                  From when should this template change be applied to generated
                  production charts?
                </Typography>
              }
              content={
                <RegenerateDialog
                  onSubmit={onSubmitStatus}
                  templates={templates}
                  onChangeEffectiveDate={onChangeEffectiveDate}
                  setTemplates={setTemplates}
                  handleClose={() => handleClickOpen(false)}
                  state={templates}
                />
              }
            />
          )}

          <DeleteModal
            open={deleteInfo.showDetails}
            handleClose={() => resetDeleteInfo()}
            onConfirm={() => confirmDelete()}
          />

          <DeleteAlertDialog
            open={deleteInfo.showTempDetails}
            isDeleteScheduledDatesDialogOpen={
              templates.isDeleteScheduledDatesDialogOpen
            }
            resetDeleteInfo={resetDeleteInfo}
            handleDeleteScheduledDatesDialog={handleDeleteScheduledDatesDialog}
            dropdownListQuery={dropdownListQuery}
            globalData={globalData}
            templateProductionDaysDetails={templateProductionDaysDetails}
            confirmDelete={confirmDelete}
            onSubmit={onSubmitStatus}
            templateDetails={templateDetails}
            isScheduledOrDelete={templates.isDeleteScheduledDatesDialogOpen}
            selectedDates={selectedDates}
            setSelectedDates={setSelectedDates}
            allDates={allDates}
            allProductionDates={allProductionDates}
            selectedProductionDates={selectedProductionDates}
            setSelectedProductionDates={setSelectedProductionDates}
            unselectedProductionDates={unselectedProductionDates}
            setUnselectedProductionDates={setUnselectedProductionDates}
            templateProductionDaysList={templateProductionDaysList}
          />

          <CustomDialogTemplate
            open={templates.isOpenDialog}
            handleBack={() => handleBack()}
            PaperProps={{
              sx: {
                minWidth: "80vw",
                height: "90vh",
              },
            }}
            title={
              !states.isCreate
                ? templateDetails?.data?.template_name
                  ? templateDetails?.data?.template_name
                  : "Generate Template"
                : templates.data.template_name
            }
            isBackArroaw={states.isCreate}
            content={renderContent(globalData, states)}
            tableFooter={renderTableFooter()}
          />
          <CustomeDialog
            PaperProps={{
              sx: {
                minWidth: "400px",
                minHeight: "200px",
              },
            }}
            closeIcon={false}
            open={states?.isErrorMessage}
            title={
              <Stack
                direction="row"
                justifyContent="space-between"
                position="sticky"
                zIndex={999}
                bgcolor="#fff"
                top={0}
              >
                <Stack direction="row" alignItems="center" ml={2}>
                  <img src="/icons/ic_pair_dialog.svg" />
                  <Typography
                    fontWeight={500}
                    variant="body1"
                    padding="15px"
                    fontSize={20}
                  >
                    Unable to Change Status
                  </Typography>
                </Stack>
              </Stack>
            }
            content={
              <TemplateStatusChangeDialog
                state={states}
                handleClose={handleClose}
              />
            }
          />

          <CustomeDialog
            PaperProps={{
              sx: {
                minWidth: "570px",
                minHeight: "280px",
                borderRadius: "10px",
              },
            }}
            open={templates?.isScheduleUpdateOpen}
            handleClose={() => handleClickUpdateOpen(false, id, true)}
            title={
              <Typography
                sx={{
                  padding: "20px 20px 8px 20px",
                  fontWeight: "500",
                  fontSize: "20px",
                  lineHeight: "24.2px",
                  width: "590px",
                }}
              >
                From when should this template change be applied to generated
                production charts?
              </Typography>
            }
            content={
              <RegenerateDialog
                onSubmit={onSubmits}
                templates={templates}
                onChangeEffectiveDate={onChangeEffectiveDate}
                setTemplates={setTemplates}
                handleClose={() => handleClickUpdateOpen(false)}
                state={templates}
              />
            }
          />
          <CustomeDialog
            PaperProps={{
              sx: {
                minWidth: "570px",
                minHeight: "280px",
                borderRadius: "10px",
              },
            }}
            open={templates.isRegenerateOpen}
            handleClose={() => handleRegenerateOpenClick(false)}
            title={
              <Typography
                sx={{
                  padding: "20px 20px 8px 20px",
                  fontWeight: "500",
                  fontSize: "20px",
                  lineHeight: "24.2px",
                  width: "590px",
                }}
              >
                From when should this template change be applied to generated
                production charts?
              </Typography>
            }
            content={
              <RegenerateDialog
                onSubmit={onUpdate}
                templates={templates}
                onChangeEffectiveDate={onChangeEffectiveDate}
                setTemplates={setTemplates}
                handleClose={() => handleRegenerateOpenClick(false)}
                isDisabled={reGenerateBatch.isPending}
              />
            }
          />
          <CustomDialogTemplate
            open={templates.isOpen}
            PaperProps={{
              sx: {
                minWidth: "80vw",
                height: "90vh",
              },
            }}
            title={
              templates.isShowErrorMessage
                ? "Adjust Product Quantities"
                : templateDetails?.data?.template_name
                  ? templateDetails?.data?.template_name
                  : "Generate Template"
            }
            content={
              <TemplateDialogContent
                templates={templates}
                setTemplates={setTemplates}
                handleBatchSplitUpdate={handleBatchSplitUpdate}
                selectedIndex={selectedIndex}
                setSelectedIndex={setSelectedIndex}
                setEditedMap={setEditedMap}
                setFocusedField={setFocusedField}
                editedMap={editedMap}
                focusedField={focusedField}
                updateBatchSplit={updateBatchSplit}
                handleAddBatch={handleAddBatch}
                handleDeleteBatch={handleDeleteBatch}
                handleDeleteBatchDialog={handleDeleteBatchDialog}
                state={state}
                handleOptionChangeRecipeBatch={handleOptionChangeRecipeBatch}
                handleOptionChangeRecipe={handleOptionChangeRecipe}
                globalData={globalData}
                handleCustomTableChange={handleCustomTableChange}
                categorylistQuery={categorylistQuery}
                handleRecipes={handleRecipes}
                onChangeFilter={onChangeFilter}
                updateTableData={updateTableData}
                onSearchChange={onSearchChange}
                searchHandler={searchHandler}
                handleCustomFieldChange={handleCustomFieldChange}
                recipelistQuery={recipelistQuery}
                states={states}
              />
            }
            tableFooter={
              templates.isShowErrorMessage ? (
                <Stack
                  sx={{ gap: "12px", padding: "12px" }}
                  direction="row"
                  justifyContent="flex-end"
                >
                  <Button
                    key="cancel"
                    variant="outlined"
                    onClick={() => handleOpenClick(false)}
                    sx={{
                      height: "36px",
                      border: "1px solid #BCC7DB",
                      borderRadius: "10px",
                      color: "#000000",
                      bgcolor: "#F5F8FC",
                    }}
                  >
                    Cancel
                  </Button>

                  <Button
                    key="generate"
                    variant="contained"
                    sx={{
                      height: "36px",
                      border: "1px solid #BCC7DB",
                      borderRadius: "10px",
                    }}
                    disabled={
                      reGenerateBatch?.isPending || hasAnyBatchError(templates)
                    }
                    onClick={() => {
                      hasLastBatchWeightZero({ templates, id });
                    }}
                    startIcon={
                      createTemplateName?.isPending ? (
                        <CircularProgress size={20} color="inherit" />
                      ) : null
                    }
                  >
                    Proceed
                  </Button>
                </Stack>
              ) : templates.isCreateDialog ? (
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  padding="12px"
                  alignItems="center"
                >
                  <Stack direction="row" spacing={1} alignItems="center">
                    <Typography>Set Template Name:</Typography>
                    <TextField
                      variant="outlined"
                      name="template_name"
                      required
                      disabled={true}
                      value={templates.data.template_name}
                      onChange={onChange}
                      sx={{
                        borderRadius: "10px",
                        height: "36px",
                        width: "405px",
                        "& .MuiOutlinedInput-root": {
                          minHeight: "28px",
                          width: "405px",
                          borderRadius: "10px",
                        },
                      }}
                      error={
                        validator.current.message(
                          "Template Name",
                          templates.data.template_name,
                          "required"
                        )
                          ? true
                          : false
                      }
                      helperText={validator.current.message(
                        "Template Name",
                        templates.data.template_name,
                        "required"
                      )}
                    />
                  </Stack>
                  <Stack sx={{ gap: "8px" }} direction="row">
                    <Button
                      key="cancel"
                      variant="outlined"
                      onClick={() => handleOpenClick(false)}
                      sx={{
                        height: "36px",
                        border: "1px solid #BCC7DB",
                        borderRadius: "10px",
                        color: "#000000",
                        bgcolor: "#F5F8FC",
                      }}
                    >
                      Cancel
                    </Button>
                    {templates.isCreateDateAssign ? (
                      <Button
                        key="generate"
                        variant="contained"
                        sx={{
                          height: "36px",
                          border: "1px solid #BCC7DB",
                          borderRadius: "10px",
                        }}
                        disabled={createTemplateName?.isPending}
                        onClick={() => {
                          !isStoreAdmin
                            ? templates.is_create_date_assign === 1
                              ? handleSubmit(
                                  true,
                                  state?.templateDetails?.data?.template_id
                                )
                              : handleNextButton()
                            : templates.is_create_date_assign === 1
                              ? handleSubmit(
                                  true,
                                state?.templateDetails?.data?.template_id
                                )
                              : handleClickUpdateOpen(
                                  false,
                                state?.templateDetails?.data?.template_id
                                );
                        }}
                        startIcon={
                          createTemplateName?.isPending ? (
                            <CircularProgress size={20} color="inherit" />
                          ) : null
                        }
                      >
                        {templates.is_create_date_assign === 1
                          ? "Next"
                          : "Skip & Next"}
                      </Button>
                    ) : (
                      <Button
                        key="generate"
                        variant="contained"
                        sx={{
                          height: "36px",
                          border: "1px solid #BCC7DB",
                          borderRadius: "10px",
                        }}
                        disabled={createTemplateName?.isPending}
                        onClick={() => handleRegenerateOpenClick(true, id)}
                        startIcon={
                          createTemplateName?.isPending ? (
                            <CircularProgress size={20} color="inherit" />
                          ) : null
                        }
                      >
                        Generate
                      </Button>
                    )}
                  </Stack>
                </Stack>
              ) : (
                <Stack
                  direction="row"
                  justifyContent="flex-end"
                  spacing={2}
                  padding="10px"
                  // sx={{
                  //   boxShadow: "0px -2px 8px 2px #0000000F",
                  // }}
                >
                  {!batchFilter1.length > 0 && (
                    <Box sx={{ alignContent: "center" }}>
                      <FormHelperText sx={{ color: "#C60808" }}>
                        The recipes field is required.
                      </FormHelperText>
                    </Box>
                  )}
                  <Button
                    variant="outlined"
                    onClick={() => handleOpenClick(false)}
                  >
                    Cancel
                  </Button>
                  <LoadingButton
                    variant="contained"
                    onClick={() => onUpdate("initial")}
                    disabled={!filterRecipeList?.length >= 1}
                    loading={reGenerateBatch?.isPending}
                  >
                    Regenerate Batches
                  </LoadingButton>
                </Stack>
              )
            }
          />
        </React.Fragment>
      }
      tabs={
        <Tabs value={search} onChange={handleChange}>
          <Tab label="Batches" value={""} />
          <Tab label="Settings" value={"?settings"} />
          {!isStoreAdmin && <Tab label="Stores" value={"?stores"} />}
        </Tabs>
      }
      sx={{
        p: 0,
        height: "calc(100vh - 145px)",
        overflowY: "auto",
        backgroundColor: search !== "" ? "#ffffff" : "initial",
      }}
    >
      {templateDetails?.isLoading ? (
        <Box
          sx={{
            position: "relative",
            top: "50%",
            transform: "translateY(-48px)",
          }}
        >
          <Loader />
        </Box>
      ) : (
        <React.Fragment>
          <CustomTabPanel value={search} index="" border={false}>
            <CommonBatchTabs
              templateDetails={templateDetails}
              templates={templates}
              handleRecipeClick={handleRecipeClick}
              setTemplates={setTemplates}
              globalData={globalData}
              value={value}
              setValue={setValue}
              handleBatchClick={handleBatchClick}
            />
          </CustomTabPanel>
          <CustomTabPanel
            value={search}
            index="?settings"
            border={false}
            style={{
              paddingInline: "16px",
              paddingBottom: "16px",
              paddingTop: "4px",
            }}
          >
            <SettingsView
              dialogBoxId={id}
              createScedule={createScedule}
              onSubmit={onSubmits}
              templates={templates}
              onDeleteTagSelect={onDeleteTagSelect}
              onChangeDate={onChangeDate}
              RadioButtonChange={RadioButtonChange}
              onChangeSceduler={onChangeSceduler}
              templateProductionDaysDetails={templateProductionDaysDetails}
              dropdownListQuery={dropdownListQuery}
              handleRepeatOptionChange={handleRepeatOptionChange}
              weekOfMonthOptionChange={weekOfMonthOptionChange}
              monthOptionChange={monthOptionChange}
              weekDaysOptionChange={weekDaysOptionChange}
              onChangeYear={onChangeYear}
              onChangeHandler={onChangeHandler}
              DaysOfWeekOptionChange={DaysOfWeekOptionChange}
              WeekDaysOptionChange={WeekDaysOptionChange}
              OptionChange={OptionChange}
              handleClickOpen={handleClickOpen}
              handleClickSaveOpen={handleClickSaveOpen}
              handleDayClick={handleDayClick}
              onChangeMultipleDate={onChangeMultipleDate}
              handleClickUpdateOpen={handleClickUpdateOpen}
              setTemplates={setTemplates}
              RemoveButtonHandeler={RemoveButtonHandeler}
              handleScheduleOpen={handleScheduleOpen}
              handleClickUpdateClose={handleClickUpdateClose}
              templateDetails={templateDetails}
              onChangeEffectiveDate={onChangeEffectiveDate}
              onSaveCustomDays={onSaveCustomDays}
              handleAddCustomDays={handleAddCustomDays}
              validator={validator}
              globalData={globalData}
              handleRemoveRecurringDate={handleRemoveRecurringDate}
              confirmDeleteRecurringDates={confirmDeleteRecurringDates}
              isEditable={isEditable}
            />
            {isStoreAdmin && (
              <TemplateStoreList
                handleStoreDeleteDialog={handleStoreDeleteDialog}
                dialogBoxId={id}
                state={state}
                setState={setState}
                assignedStoreState={assignedStoreState}
                handleModal={handleModal}
                handleStoreDialogSelect={handleStoreDialogSelect}
                handleStoreToRecipe={handleStoreToRecipe}
                onSearchHandler={onSearchHandler}
                pagination={pagination}
                setPagination={setPagination}
                assingedStoreListQueryTemplate={assingedStoreListQueryTemplate}
                confirmDeleteStrores={confirmDeleteStrores}
                storesDeleteInfo={storesDeleteInfo}
                clearStoresDeleteInfo={clearStoresDeleteInfo}
                handleDeleteStores={handleDeleteStores}
                sorting={sorting}
                setSorting={setSorting}
                isLoading={isLoading}
                createScedule={createScedule}
                templates={templates}
                handleClickOpen={handleClickOpen}
                handleClickSaveOpen={handleClickSaveOpen}
                handleAlertClickOpen={handleAlertClickOpen}
                handleClickUpdateClose={handleClickUpdateClose}
                templateDetails={templateDetails}
                onChangeStoreEffectiveDate={onChangeStoreEffectiveDate}
                onChangeEffectiveDates={onChangeEffectiveDates}
                isStoreAdmin={true}
                isEditable={isEditable}
              />
            )}
          </CustomTabPanel>
          <CustomTabPanel value={search} border={false} index="?stores">
            <TemplateStoreList
              handleStoreDeleteDialog={handleStoreDeleteDialog}
              dialogBoxId={id}
              state={state}
              setState={setState}
              assignedStoreState={assignedStoreState}
              handleModal={handleModal}
              handleStoreDialogSelect={handleStoreDialogSelect}
              handleStoreToRecipe={handleStoreToRecipe}
              onSearchHandler={onSearchHandler}
              pagination={pagination}
              setPagination={setPagination}
              assingedStoreListQueryTemplate={assingedStoreListQueryTemplate}
              confirmDeleteStrores={confirmDeleteStrores}
              storesDeleteInfo={storesDeleteInfo}
              clearStoresDeleteInfo={clearStoresDeleteInfo}
              handleDeleteStores={handleDeleteStores}
              sorting={sorting}
              setSorting={setSorting}
              isLoading={isLoading}
              createScedule={createScedule}
              templates={templates}
              handleClickOpen={handleClickOpen}
              handleClickSaveOpen={handleClickSaveOpen}
              handleAlertClickOpen={handleAlertClickOpen}
              handleClickUpdateClose={handleClickUpdateClose}
              templateDetails={templateDetails}
              onChangeStoreEffectiveDate={onChangeStoreEffectiveDate}
              onChangeEffectiveDates={onChangeEffectiveDates}
              isStoreAdmin={false}
              isStoreAssign={isStoreAssign}
              isEditable={isEditable}
            />
          </CustomTabPanel>
        </React.Fragment>
      )}

      <CustomeDialog
        title="Rename Template"
        divider={false}
        open={templates?.isNameOpen}
        CloseIcons={false}
        content={
          <NameDialog
            onChange={onChange}
            onSubmit={onNameSubmit}
            state={templates}
            isEdit={id}
            validator={validator}
            handleClose={() => handleNameOpen(false)}
            isDisabled={updateTemplateName.isPending}
          />
        }
      />
    </PageListLayout>
  );
};
